import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../config/config';
import axios from 'axios';

const EditNavCoursePage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        pageName: '',
        bannerHeading: '',
        bannerText: '',
        title: '',
        heading: '',
        subHeading: '',
        imgHeading: '',
        imgpara1: '',
        imgpara2: '',
        tableHeading: '',
        tableText: '',
        image: null,
        oldImage: '', // for showing existing image
    });

    useEffect(() => {
        // Fetch existing data to prefill form
        const fetchData = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/getSingle_collegespage/${id}`);
                const data = response.data;

                setFormData({
                    ...formData,
                    pageName: data.pageName,
                    bannerHeading: data.bannerHeading,
                    bannerText: data.bannerText,
                    title: data.title,
                    heading: data.heading,
                    subHeading: data.subHeading,
                    imgHeading: data.imgHeading,
                    imgpara1: data.imgpara1,
                    imgpara2: data.imgpara2,
                    tableHeading: data.tableHeading,
                    tableText: data.tableText,
                    image: data.image,
                });
            } catch (error) {
                console.error('Error fetching course:', error);
            }
        };

        fetchData();
    }, [id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setFormData({ ...formData, image: e.target.files[0] });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        formDataToSend.append('pageName', formData.pageName);
        formDataToSend.append('bannerHeading', formData.bannerHeading);
        formDataToSend.append('bannerText', formData.bannerText);
        formDataToSend.append('title', formData.title);
        formDataToSend.append('heading', formData.heading);
        formDataToSend.append('subHeading', formData.subHeading);
        formDataToSend.append('imgHeading', formData.imgHeading);
        formDataToSend.append('imgpara1', formData.imgpara1);
        formDataToSend.append('imgpara2', formData.imgpara2);
        formDataToSend.append('tableHeading', formData.tableHeading);
        formDataToSend.append('tableText', formData.tableText);

        if (formData.image) {
            formDataToSend.append('image', formData.image);
        }

        try {
            const response = await axios.put(`${config.API_BASE_URL}/api/admin/update_navcoursespage/${id}`, formDataToSend);

            if (response.data.code === 200) {
                alert('Course updated successfully');
                navigate("/admin/navcoursepagelist");
            } else {
                alert('Error updating course');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was an error with your request.');
        }
    };

    return (
        <div className="container mt-5 pt-5">
          <div className="row">
            <div className="col-lg-2"></div>
            <div className="col-lg-10">
            <h2>Edit Course</h2>
            <form onSubmit={handleSubmit}>
                {/* Page Name */}
                <div className="mb-3">
                    <label className="form-label">Page Name</label>
                    <input
                        type="text"
                        className="form-control"
                        name="pageName"
                        value={formData.pageName}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Banner Heading */}
                <div className="mb-3">
                    <label htmlFor="bannerHeading" className="form-label">Banner Heading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="bannerHeading"
                        name="bannerHeading"
                        value={formData.bannerHeading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Banner Text */}
                <div className="mb-3">
                    <label htmlFor="bannerText" className="form-label">Banner Text</label>
                    <textarea
                        className="form-control"
                        id="bannerText"
                        name="bannerText"
                        rows="3"
                        value={formData.bannerText}
                        onChange={handleInputChange}
                        required
                    ></textarea>
                </div>

                {/* Title Text */}
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title</label>
                    <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Table Heading */}

                <div className="mb-3">
                    <label htmlFor="tableHeading" className="form-label">Table Heading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="tableHeading"
                        name="tableHeading"
                        value={formData.tableHeading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Table Text */}
                <div className="mb-3">
                    <label htmlFor="tableText" className="form-label">Table Text</label>
                    <textarea
                        className="form-control"
                        id="tableText"
                        name="tableText"
                        rows="3"
                        value={formData.tableText}
                        onChange={handleInputChange}
                        required
                    ></textarea>
                </div>


                {/* Heading */}
                <div className="mb-3">
                    <label htmlFor="heading" className="form-label">Container Main Heading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="heading"
                        name="heading"
                        value={formData.heading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Subheading */}
                <div className="mb-3">
                    <label htmlFor="subHeading" className="form-label">Container Main Subheading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="subHeading"
                        name="subHeading"
                        value={formData.subHeading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Existing Image */}
                <div className="mb-3">
                    <label className="form-label">Old Image:</label><br />
                    <img src={`${config.API_BASE_URL}/uploads/${formData.image}`} alt="Old" style={{ width: '200px' }} />
                </div>

                {/* Upload New Image */}
                <div className="mb-3">
                    <label className="form-label">Upload New Image (optional)</label>
                    <input
                        type="file"
                        className="form-control"
                        name="image"
                        onChange={handleImageChange}
                    />
                </div>

                {/* Image Heading */}
                <div className="mb-3">
                    <label htmlFor="imgHeading" className="form-label">Image Heading</label>
                    <input
                        type="text"
                        className="form-control"
                        id="imgHeading"
                        name="imgHeading"
                        value={formData.imgHeading}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                {/* Image Paragraphs */}
                <div className="mb-3">
                    <label htmlFor="imgpara1" className="form-label">Image Paragraph 1</label>
                    <textarea
                        className="form-control"
                        id="imgpara1"
                        name="imgpara1"
                        rows="3"
                        value={formData.imgpara1}
                        onChange={handleInputChange}
                        required
                    ></textarea>
                </div>

                <div className="mb-3">
                    <label htmlFor="imgpara2" className="form-label">Image Paragraph 2</label>
                    <textarea
                        className="form-control"
                        id="imgpara2"
                        name="imgpara2"
                        rows="3"
                        value={formData.imgpara2}
                        onChange={handleInputChange}
                        required
                    ></textarea>
                </div>

                {/* Submit Button */}
                <button type="submit" className="btn btn-primary">Update</button>
            </form>
            </div>
          </div>
        </div>
    );
};

export default EditNavCoursePage;
